 export enum RequeteurPropEnum {
Adresse = 0,
Annee = 1,
Bban = 2,
Bic = 3,
CTVABU = 4,
ChargesSalariales = 5,
CleSecu = 6,
CodeAutreCaisse = 7,
CodeCaisseComplementaire = 8,
CodeClassification = 9,
CodeCodeInsee = 10,
CodeConventionCollective = 11,
CodeDepart = 12,
CodeDureeContrat = 13,
CodeGestionConge = 14,
CodeMaladieRetraite = 15,
CodeMotifRuptureContrat = 16,
CodeNationalite = 17,
CodeNatureContrat = 18,
CodeQualification = 19,
CodeRegime = 20,
CodeRemuneration = 21,
CodeService = 22,
CodeSexe = 23,
CodeSociete = 24,
CodeTypeContrat = 25,
CoefficiantBulletin = 26,
CommuneCodePostal = 27,
CommuneLibelle = 28,
CongesAcquis = 29,
CongesDroitOuvert = 30,
CongesPris = 31,
CongesPrisMois = 32,
CotisationsPatronales = 33,
Crpcen = 34,
DateDebut = 35,
DateDebutContrat = 36,
DateDebutTransfert = 37,
DateDepart = 38,
DateEntree = 39,
DateFin = 40,
DateFinContrat = 41,
DateNaissance = 42,
DateVirement = 43,
Domiciliation = 44,
DureeContrat = 45,
EmailProfessionnel = 46,
HeuresBulletin = 47,
IJAccidentTravailBrut = 48,
IJMaladieBrut = 49,
IJMaterniteBrut = 50,
IbanCC = 51,
IbanCP = 52,
IdResponsableHierarchique = 53,
LibelleEmploi = 54,
MailPerso = 55,
Mode = 56,
Mois = 57,
Montant = 58,
Nationalite = 59,
Nature = 60,
NetAPayer = 61,
NetDu = 62,
NetImposable = 63,
Nom = 64,
NombreJours = 65,
NomNaissance = 66,
NotaireResponsable = 67,
NumSecu = 68,
NumeroBulletin = 69,
NumeroContrat = 70,
NumeroSalarie = 71,
PersonneAPrevenirNom = 72,
PersonneAPrevenirTel = 73,
Prenom = 74,
ProrataPresence = 75,
Qualification = 76,
RttAcquis = 77,
RttDroitOuvert = 78,
RttPris = 79,
RttPrisMois = 80,
SalaireBase = 81,
SalaireBrutApresIJ = 82,
SalaireBrutAvantIJ = 83,
TelFixe = 84,
TelPortable = 85,
Titulaire = 86,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/RequeteurPropEnum.ts